import { DateTime } from 'luxon';
import { UserType } from '../common/commonTypes';

export const isTrialExpired = (createdAt: string): boolean => {
    const createdDate = DateTime.fromISO(createdAt);
    const now = DateTime.now();
    const diffInDays = now.diff(createdDate, 'days').days;

    return diffInDays > 8;
};

export const isUserUnsubscribed = (user: UserType): boolean => {
    return !user?.settings?.subscribed && isTrialExpired(user.createdAt);
};
